import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, OnInit, ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { BrandInformationService } from '../../brand-information.service';
import { InformationPageService } from '../../../information-page/information-page.service';
import { ProductGroupsService } from 'shared/product-groups/product-groups.service';
import { BrandService } from 'shared/brand/brand.service';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { PRODUCT_GROUPS_NAME } from '../../variables';
import { ProductGroupsFormComponent } from './product-groups-form.component';
import { PermissionsService } from 'shared/permissions/permissions.service';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';
import {BRAND_NAME} from '../../../account-information/variables';


@Component({
  moduleId: module.id,
  selector: 'product-groups-segment',
  template: `
    <product-groups-form
      [data]='data'
      [segmentData]='segmentData'
      [savingEvents]="productGroupsService.isSavedObservable"
      (cancel)='cancelClickHandler()'
      (saveChanges)='saveChangesClickHandler()'
    ></product-groups-form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ProductGroupsComponent extends BaseSegmentComponent implements OnInit {
  name: string = PRODUCT_GROUPS_NAME;

  @ViewChild(ProductGroupsFormComponent, {static: true})
  // @ts-ignore
  protected formComponent: ProductGroupsFormComponent;

  constructor(
    public productGroupsService: ProductGroupsService,
    protected router: Router,
    protected brandInformationService: BrandInformationService,
    protected informationPageService: InformationPageService,
    protected permissionsService: PermissionsService,
    protected ref: ChangeDetectorRef,
    private brandService: BrandService,
  ) {
    super(
      router,
      brandInformationService,
      informationPageService,
      permissionsService,
      ref,
    );
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    super.ngOnInit();
    this.refresh();
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  fetchFormData(): Observable<any> {
    return this.productGroupsService.fetch(this.brandService.getBrand(), true);
  }

  putFormData(): Observable<any> {
    const data = this.formComponent.productGroupsFormData.value;
    return this.productGroupsService.put(this.brandService.getBrand(), data);
  }

  getError() {
    return this.formComponent && this.formComponent.getError();
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

   private createProductGroupsItem(item: any = {
      code: '',
      description: '',
      items: '0',
      group: '',
      sub_group: '',
    }) {
    return Object.assign({}, item);
  }

  cancelClickHandler() {
    this.informationPageService.emitCancel(BRAND_NAME);
  }

  saveChangesClickHandler() {
    this.informationPageService.emitShowBeforeSaveModal();
  }

  onSaved(event: any) {
    this.productGroupsService.emitIsSaved();
  }

  protected showLoader() {
    this.formComponent.loader.show();
  }

  protected hideLoader() {
    this.formComponent.loader.hide();
  }
}
